<template>
  <illustration-layout :cclink="this.$store.state.cclink + 'SHOWCASE'">
    <div :style="`background-color:#${bgcolor};color:#${fgcolor};font-weight:500;font-size:53px;text-align:center;padding:28px`" v-html="item.title"></div>
    <div v-if="item.news_title" :style="`background-color:#${bottomBannerColor};text-align:center;padding:35px;font-size:24px;line-height:32px`" v-html="item.news_title"></div>
    <template v-if="item.intro && item.agent_id">
      <table border="0" cellspacing="0" cellpadding="0" style="width:100%;padding:28px;">
        <tr valign="top">
          <td><img :src="`https://media.illustrationx.com/mediastore/contacts/${item.agent_id}.jpg`" width="140"  ></td>
          <td v-html="item.intro" style="padding:2px 16px 0;white-space: pre-line; font-size:14px"></td>
        </tr>
      </table>
      <div :style="`background-color:#${bottomBannerColor};height:4px`"></div>
    </template>
    <div style="text-align:center;padding:0 35px 35px 35px">
      <showcase-panel v-for="(artist,index) in item.artists" :key="artist.portfolio_url" :artist="artist"
        :last="index === item.artists.length -1" :hidefol="!item.showfol" :colors="item" :showArtist="item.show_artists" />
    </div>
    <div v-if="item.intro && (!item.agent_id)" :style="`background-color:#${bottomBannerColor};text-align:center;padding:35px;font-size:24px;line-height:32px`" >
      {{ item.intro }}
    </div>
    
    
  </illustration-layout>
</template>

<script>
import ShowcasePanel from '../components/ShowcasePanel.vue'
import NewTalentLoader from '../mixins/NewTalentLoader'
import IllustrationLayout from '../layouts/IllustrationLayout.vue'
export default {
  components: {
    ShowcasePanel,
    IllustrationLayout
  },
  computed: {
    fgcolor() {
      if(this.item.fgcolor) {
        return this.item.fgcolor
      }
      return 'FFFFFF'
    },
    bgcolor() {
      if(this.item.bgcolor) {
        return this.item.bgcolor
      }
      return '8B6F4B'
    },
    bottomBannerColor() {
      return this.item.bottomBannerColor || 'E7E2DB'
    }
  },
  mixins: [NewTalentLoader]

}
</script>

<style>
b {
  font-size:23px;
}
</style>